import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PageStyles,
  PageSubtitleStyles,
  PageTitleStyles,
} from './GreetFullAI.styles';

export const ScreenGreetFullAI: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Greet Full AI',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles
      background="none"
      bgImage={
        <div className="page-bg">
          <img
            src="../assets/layout-screens/greet-full-ai/bg-mask.png"
            alt="Mask"
            className="page-bg-image-mask"
          />
          <img
            src="../assets/layout-screens/greet-full-ai/girl-bg.png"
            alt="Background"
            className="page-bg-image"
          />
        </div>
      }
      bgImageMask={false}
    >
      <IonContent>
        <LogoWithAppName className="app-logo" />

        <PageTitleStyles
          className="page-title"
          component="h1"
          variant="headline-large"
          align="center"
        >
          Create your Own
          <br />
          <PageSubtitleStyles
            variant="inherit"
            color="gradient"
            component="span"
            className="page-subtitle"
          >
            AI Girlfriend
          </PageSubtitleStyles>
        </PageTitleStyles>
      </IonContent>

      <OnboardingFooter
        buttonClassName="page-footer-button"
        onContinue={handleNextStep}
        buttonText="Get started"
      />
    </PageStyles>
  );
};
